import { Card, HStack, Skeleton, VStack } from '@chakra-ui/react';

export default function SkeletonCard() {
  return (
    <Card.Root>
      <Card.Body p={6}>
        <VStack align="stretch" gap={4}>
          <HStack justify="space-between">
            <Skeleton height="16px" width="60%" />
            <Skeleton height="16px" width="16px" />
          </HStack>
          <HStack justify="space-between" align="flex-end">
            <VStack align="flex-start" gap={2}>
              <Skeleton height="32px" width="80px" />
              <Skeleton height="12px" width="120px" />
            </VStack>
            <Skeleton height="20px" width="60px" />
          </HStack>
        </VStack>
      </Card.Body>
    </Card.Root>
  );
}
